import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTIcon} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'

const Filter = () => {
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [trashedStatus, setTrashedStatus] = useState<string>('')

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})

    setTrashedStatus('without_trash')
  }

  const filterData = () => {
    updateState({
      filter: {trashedStatus: trashedStatus},
      ...initialQueryState,
    })
  }
  const filterTrashedHandler = (value) => {
    setTrashedStatus(value)
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button> 
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
       
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>

        <div className='separator border-gray-200'></div>
         
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
           
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'> Select Trashed Records:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              placeholder='Select Filter'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='trashedStatus'
              data-hide-search='true'
              onChange={(e) => filterTrashedHandler(e.target.value)}
              value={trashedStatus}
            >
              <option value='without_trash'>With out Trashed</option>
              <option value='with_trashed'>With Trashed</option>
              <option value='trashed'>Only Trashed</option>
            </select>
          </div> 
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={isLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div> 
        </div> 
      </div> 
    </>
  )
}

export {Filter}
